/* ------------------------------------*\
    #JavaScript Utilities
\*------------------------------------ */
import logger from './module/logger';

const Utils = {
    logger,
    positionStickySupport: (() => {
        let hasSupport = null;
        /**
         * Feature-detection for `position:sticky` Support.
         * @returns {boolean} Browser-Support for `position:sticky`
         *
         * @link https://trialstravails.blogspot.com/2016/06/detecting-css-position-sticky-support.html
         */
        return () => {
            if (hasSupport == null) {
                const elem = document.createElement('a');
                const elemStyle = elem.style;
                // @TODO: consider adding class and handle styles via CSS, not inline styles via JS
                elemStyle.cssText = 'position:sticky;position:-webkit-sticky;';

                hasSupport = elemStyle.position.indexOf('sticky') !== -1;
            }

            return hasSupport;
        };
    })(),

    /**
     * Utility function to get closest parent element with specific class
     * @param {object} el DOM-object of element
     * @param {string} cls Class of parent element
     *
     * @TODO: util not used, remove
     */
    findAncestor(el, cls) {
        return el.closest(`.${cls}`);
    },

};

export default Utils;
